<template>
  <div class="create-product-modal-component">
    <div class="header">
      <h2>{{ $t("products.createProductModal.title") }}</h2>
    </div>
    <div class="content">
      <v-file-input
        class="thumbnail-input"
        accept="image/png, image/jpeg, image/bmp, image/svg"
        prepend-icon="mdi-camera"
        :label="$t('products.createProductModal.labels.thumbnail')"
        variant="outlined"
        v-model="thumbnail"
        ref="thumbnailFileInput"
        @input="onSelectFileThumbnail($event)"
      ></v-file-input>
      <v-file-input
        class="cover-image-input"
        accept="image/png, image/jpeg, image/bmp, image/svg"
        prepend-icon="mdi-camera"
        :label="$t('products.createProductModal.labels.coverImage')"
        variant="outlined"
        v-model="coverImage"
        ref="coverImageFileInput"
        @input="onSelectFileCoverImage($event)"
      ></v-file-input>
      <v-select
      v-model="selectedLayout"
      :items="layouts"
      :label="$t('products.createProductModal.labels.layer')"
      variant="outlined"
      item-title="title"
      item-value="id"
      ></v-select>
      <v-checkbox
      v-model="canSold"
      :label="$t('products.createProductModal.labels.canSold')"
      variant="outlined"
      disabled
      ></v-checkbox>
      <v-select
        v-model="selectedTag"
        :items="tags"
        variant="outlined"
        item-title="name"
        item-value="id"
        :label="$t('products.createProductModal.labels.tag')"
      ></v-select>
      <v-select
        v-model="selectedLanguage"
        :items="availableLanguages"
        variant="outlined"
        item-title="title"
        item-value="id"
        :label="$t('products.createProductModal.labels.description_language')"
      ></v-select>
      <div class="mb-5">
        <p class="mb-2">
          {{ $t("products.createProductModal.labels.description") }}
        </p>
        <quill-editor
          theme="snow"
          contentType="html"
          v-model:content="productDescription"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
          @ready="onEditorReady($event)"
        ></quill-editor>
      </div>
    </div>
    <div class="button-row">
      <v-btn :disabled="isLoading" @click="closeModal">
        {{ $t("products.createProductModal.buttons.cancel") }}
      </v-btn>
      <v-btn
        :loading="isLoading"
        :disabled="isLoading"
        color="primary"
        @click="saveProduct"
      >
        {{ $t("products.createProductModal.buttons.save") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreateProductModalComponent",
  props: {
    product: {
      type: Object,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      availableLanguages: [],
      selectedLanguage: undefined,
      // just mock ->
      layouts: [],
      //
      thumbnail: null,
      coverImage: null,
      productDescription: undefined,
      selectedLayout: undefined,
      canSold: true,
      updatableProduct: undefined,
      productDescriptions: [],
      isLoading: false,
      tags: [],
      selectedTag: null,
    };
  },
  mounted() {
    this.getProductLayout();
    this.updatableProduct = this.product;
    this.productDescriptions = this.product.product_name;
    this.tags = this.product.tags;
    this.selectedTag = this.product.tag_id
    this.availableLanguages = this.languages.map((item) => {
      return {
        languageCode: item.code2,
        title: /* this.$t(`languages.${item.code2}`) */ item.name,
        id: item.id,
      };
    });
    this.selectedLanguage = this.availableLanguages[0];
    this.availableLanguages.map((item) => {
      if (item.languageCode === "hu") {
        this.selectedLanguage = item.id;
      }
    });

    this.canSold = this.product.can_sold;

    if (this.product.thumbnail_base64) {
      const iconThumbnail = document.querySelector(
        ".thumbnail-input .mdi-camera"
      );
      const thumbnail = document.createElement("img");
      const thumbnailSrc = document.querySelector(
        ".thumbnail-input .v-input__prepend"
      );

      iconThumbnail.remove();
      thumbnail.src = this.product.thumbnail_base64;
      thumbnail.classList.add("prepend-img", "v-icon--clickable");
      thumbnail.setAttribute("role", "button");
      thumbnail.addEventListener("click", this.chooseThumbnail);
      thumbnailSrc.appendChild(thumbnail);
    }
    if (this.product.cover_image_base64) {
      const iconCoverImage = document.querySelector(
        ".cover-image-input .mdi-camera"
      );
      const coverImage = document.createElement("img");
      const coverImageSrc = document.querySelector(
        ".cover-image-input .v-input__prepend"
      );

      iconCoverImage.remove();
      coverImage.src = this.product.cover_image_base64;
      coverImage.classList.add("prepend-img", "v-icon--clickable");
      coverImage.setAttribute("role", "button");
      coverImage.addEventListener("click", this.chooseCoverImage);
      coverImageSrc.appendChild(coverImage);
    }
  },
  methods: {
    ...mapActions({}),
    getProductLayout() {
      this.layouts = this.product.layout_sector;
    },
    chooseThumbnail() {
      this.$refs.thumbnailFileInput.click();
    },
    chooseCoverImage() {
      this.$refs.coverImageFileInput.click();
    },
    onSelectFileThumbnail() {
      const input = this.$refs.thumbnailFileInput;
      const files = input.files;
      const reader = new FileReader();
      const img = document.createElement("img");
      const src = document.querySelector(".thumbnail-input .v-input__prepend");
      if (files && files[0]) {
        reader.onload = (e) => {
          src.innerHTML = "";
          img.src = e.target.result;
          img.classList.add("prepend-img", "v-icon--clickable");
          img.setAttribute("role", "button");
          img.addEventListener("click", this.chooseCoverImage);
          src.appendChild(img);
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onSelectFileCoverImage() {
      const input = this.$refs.coverImageFileInput;
      const files = input.files;
      const reader = new FileReader();
      const img = document.createElement("img");
      const src = document.querySelector(
        ".cover-image-input .v-input__prepend"
      );
      if (files && files[0]) {
        reader.onload = (e) => {
          src.innerHTML = "";
          img.src = e.target.result;
          img.classList.add("prepend-img", "v-icon--clickable");
          img.setAttribute("role", "button");
          img.addEventListener("click", this.chooseCoverImage);
          src.appendChild(img);
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    saveProduct() {
      const bodyFormData = new FormData();

      if (this.thumbnail) bodyFormData.append("thumbnail", this.thumbnail[0]);
      if (this.coverImage)
        bodyFormData.append("cover_image", this.coverImage[0]);
      bodyFormData.append("id", this.product.id);

      this.isLoading = true;
      let sendedProduct = {};
      sendedProduct = this.product;
      sendedProduct.can_sold = this.canSold;
      sendedProduct.layout_id = this.selectedLayout;
      sendedProduct.tag_id = this.selectedTag;
      this.$emit(
        "saveProduct",
        sendedProduct,
        this.productDescriptions,
        bodyFormData
      );
    },
    closeModal() {
      // azért volt, mert másképp a dropdown elemre kattintva bezáródott a modal
      // ki lett véve az outside-click, csak a bezárás gombbal lehet bezárni a modalt
      // if (document.activeElement.tagName != "INPUT") {
      this.$emit("closeModal");
      // }
    },
    onEditorBlur() {},
    onEditorFocus() {},
    onEditorChange() {},
    onEditorReady() {},
  },
  watch: {
    selectedLanguage: {
      handler() {
        this.updatableProduct.product_name.map((item) => {
          if (item.language_id === this.selectedLanguage) {
            this.productDescription = item.description;
          }
        });
      },
    },
    productDescription: {
      handler() {
        let foundDescription = false;
        this.productDescriptions.map((descriptionObject) => {
          if (this.selectedLanguage === descriptionObject.language_id) {
            foundDescription = true;
            descriptionObject.description = this.productDescription;
          }
        });
        if (!foundDescription) {
          let selectedLanguageName;
          this.languages.map((item) => {
            if (item.id === this.selectedLanguage) {
              selectedLanguageName = item.name;
            }
          });
          let newDescriptionObject = {
            language_id: this.selectedLanguage,
            name: selectedLanguageName,
            description: this.productDescription,
          };
          this.productDescriptions.push(newDescriptionObject);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.create-product-modal-component {
  @media (max-width: 600px) {
    min-width: 320px;
  }
  min-width: 520px;
  padding: 24px;
  .button-row {
    display: flex;
    justify-content: space-between;
  }
}
.logo {
  max-width: 150px;
  height: auto;
}
::v-deep(.v-input__prepend img) {
  max-width: 50px;
  height: auto;
}

.logo-input {
  ::v-deep(.v-field__input) {
    display: block;
  }
}
</style>
